import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import RowNoData from '@/components/elements/RowNoData';
import { GetPuntuarUsuario, PuntuarUsuarioLibroObj } from '@/objects/Articles';
import Subtitulo from '@/components/elements/Subtitulo';
import RowPuntarUsuarioLibro from '@/components/elements/listas/lista_puntuar/RowPuntuarUsuarioLibro';

function PuntuacionesUser() {

    const { articulosQueries } = useServices();

    const [puntuarRow, setPuntuarRow] = React.useState<PuntuarUsuarioLibroObj[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        cargarChats();
    }, []);

    function cargarChats() {
        const datosUsuario = cargarDatosUsuario();
        articulosQueries?.obtenerArticulosSinPuntuar(Number(datosUsuario?.id_user)).then((response: AxiosResponse<GetPuntuarUsuario>) => {
            const puntuarUsuarioLibro: PuntuarUsuarioLibroObj[] = response.data.puntuar;
            setPuntuarRow(puntuarUsuarioLibro);
        }
        ).catch((error: any) => {

        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloPrincipalH1 texto={t("menu:secciones.puntuaciones.titulo")} />
            <Subtitulo texto={t("menu:secciones.puntuaciones.compras_sin_puntuar")} />
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                {puntuarRow.length > 0 ? puntuarRow.map((puntuacionObj: PuntuarUsuarioLibroObj, index: number) => {
                    return (
                        <section style={{ display: 'flex', flexDirection: 'column', width: "100%", margin: "10px", alignItems: "center" }} key={index}>
                            <RowPuntarUsuarioLibro t={t} puntuacionObj={puntuacionObj} onCargar={cargarChats} />
                        </section>
                    );
                }) : <RowNoData texto={t("menu:secciones.puntuaciones.no_hay_libros_para_puntuar_compra_uno")} />}
            </section>
        </section>
    );
}

export default PuntuacionesUser;